import { Container } from 'reactstrap';
import { NavLink } from 'react-router-dom';
import * as React from 'react';
const Footer = () => (
    <>
        <div className="footer">
            <Container fluid={true}>
                <ul>
                    <li>
                        &copy; 2023 AscentHR - Technology & Survey Partner
                    </li>
                    {/* <li>
                        <NavLink to="/terms-of-service">
                            Terms of Service
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/privacy-policy">
                            Privacy Policy
                        </NavLink>
                    </li>
                    <li>
                        <NavLink to="/send-feedback">
                            Send Feedback
                        </NavLink>
                    </li> */}
                </ul>
            </Container>
        </div>
    </>
)
export default Footer;
